module.exports = __webpack_public_path__ + "static/venue-of-hollywood-logo-with-text-55880d4881a08abb61d443637b9f4451.png";